/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreProjectUserResponseDto } from '../../models/core-project-user-response-dto';

export interface ProjectUsersControllerDeleteByProjectAndUser$Params {
  tenant: string;
  projectId: string;
  userId: string;
}

export function projectUsersControllerDeleteByProjectAndUser(http: HttpClient, rootUrl: string, params: ProjectUsersControllerDeleteByProjectAndUser$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreProjectUserResponseDto>> {
  const rb = new CoreRequestBuilder(rootUrl, projectUsersControllerDeleteByProjectAndUser.PATH, 'delete');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('projectId', params.projectId, {});
    rb.path('userId', params.userId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<CoreProjectUserResponseDto>;
    })
  );
}

projectUsersControllerDeleteByProjectAndUser.PATH = '/o2-core/project-users/{tenant}/by-ids/{projectId}/{userId}';
